<template>
  <div class="ccui-app-container">
    <div
      class="ccui-advanced-search-wrapper ccui-clearfix"
      ref="advancedSearchWrapper"
    >
      <el-search
        :formProp="formData"
        @search="searchItem"
        :isShowSearch="isShowSearch"
        class="ccui-highsearch"
        :selectClear="true"
        width="420px"
      >
        <div class="ccui-tab-wrapper">
          <el-button
            :type="isFocus === 1 ? 'table-top-active' : 'table-top'"
            size="mini"
            >商品列表</el-button
          >
        </div>
        <template slot="search">
          <el-input
            v-model="formData.spuTitle"
            clearable
            searchLabel="产品标题"
            placeholder="请输入产品标题模糊查询"
          ></el-input>
          <el-input
            v-model="formData.spuId"
            clearable
            searchLabel="产品编码"
            placeholder="请输入产品编码查询"
          ></el-input>
          <el-cascader
            v-model="formData.caterycode"
            searchLabel="商品分类"
            placeholder="请选择商品分类查询"
            ref="idCascader"
            :options="options"
            :props="propsPlace"
            clearable
          >
          </el-cascader>
          <el-input
            v-model="formData.shopName"
            clearable
            searchLabel="店铺名称"
            placeholder="请输入店铺名称模糊查询"
          ></el-input>
          <el-input
            v-model="formData.brandName"
            clearable
            searchLabel="品牌"
            placeholder="请输入品牌模糊查询"
          ></el-input>
          <el-date-picker
            v-model="formData.applyTime"
            searchLabel="申请时间区间"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </template>
        <el-input
          v-model="formData.spuTitle"
          clearable
          searchLabel="产品标题"
          placeholder="请输入产品标题模糊查询"
          slot="searchItem1"
        ></el-input>
        <el-input
          v-model="formData.spuId"
          clearable
          searchLabel="产品编码"
          placeholder="请输入产品编码查询"
          slot="searchItem2"
        ></el-input>
        <el-cascader
          v-model="formData.caterycode"
          searchLabel="商品分类"
          placeholder="请选择商品分类查询"
          ref="idCascader"
          :options="options"
          :props="propsPlace"
          clearable
          slot="searchItem3"
        >
        </el-cascader>
        <el-input
          v-model="formData.shopName"
          clearable
          searchLabel="店铺名称"
          placeholder="请输入店铺名称模糊查询"
          slot="searchItem4"
        ></el-input>
        <el-input
          v-model="formData.brandName"
          clearable
          searchLabel="品牌"
          placeholder="请输入品牌模糊查询"
          slot="searchItem5"
        ></el-input>
        <el-date-picker
          v-model="formData.applyTime"
          searchLabel="申请时间区间"
          clearable
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          slot="searchItem6"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-search>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <GoodsList @selected="selectedItem" :tableDataList="tableData">
      </GoodsList>
      <div class="ccui-table-footer" v-show="isShowPagination">
        <div v-show="selectData.length" class="ccui-operation">
          <el-popover
            placement="top-start"
            width="160"
            trigger="hover"
            popperClass="btn ccui-operation-publish"
            v-model="visible"
          >
            <div style="text-align: right; margin: 0" class="el-popper-btn">
              <el-button
                class="export-excel-button"
                size="mini"
                @click="handleApproval(0)"
                >审批通过</el-button
              >
              <el-button
                class="export-excel-button"
                size="mini"
                @click="handleApproval(1)"
                >审批不通过</el-button
              >
              <el-button
                class="export-excel-button"
                size="mini"
                @click="handleApproval(2)"
                >审批退回</el-button
              >
            </div>
            <el-button style="background-color: #F6F6F6;" slot="reference"
              >批量审批<i class="el-icon-caret-top"
            /></el-button>
          </el-popover>
        </div>
        <div id="ccui-paging" v-if="totalNum > 0">
          <el-pagination
            :total="totalNum"
            :page-size="getPageSizeCode"
            :current-page="pageNoCode"
            background
            layout="total, prev, pager, next, jumper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/config/mock"; // mock数据
import GoodsList from "./components/goods-publish-table";
import { getList, getAllprovince } from "../api/publish-list";
import { numberFilter, ishasAgentId } from "@/basa/utils";
export default {
  name: "goods-list",
  components: {
    GoodsList
  },
  data() {
    return {
      // tabs页签标识
      isFocus: 1,
      // Todo 高级搜索数据 start
      isShowSearch: true,
      formData: {
        spuTitle: "",
        spuId: "",
        caterycode: "",
        shopName: "",
        brandName: "",
        applyTime: ""
      },
      options: [],
      propsPlace: {
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            getAllprovince({ code: 0 }).then(response => {
              const cities = response.data.data.map((value, i) => ({
                value: value.code,
                label: value.name,
                leaf: false
              }));
              resolve(cities);
            });
          }
          if (node.level >= 1) {
            getAllprovince({ code: node.value }).then(response => {
              const areas = response.data.data.map((value, i) => ({
                value: value.code,
                label: value.name,
                leaf: !(value.lastFlag === 0)
              }));
              resolve(areas);
            });
          }
        }
      },
      value: "",
      // Todo 高级搜索数据 end

      // Todo 表格数据 start
      visible: false,
      totalNum: 0,
      pageNoCode: 1,
      isShow1: false,
      isSelection: false,
      tableData: [],
      selectData: [],
      tableParams: {
        tabId: 1
      },
      isShowPagination: false
      // Todo 表格数据 end
    };
  },
  computed: {
    getPageSizeCode() {
      // 获取表格所占区域的总高度
      let appContainerHeight = document.documentElement.clientHeight - 200;
      // 表格总高度 - 搜索区域高度 - 底部分页高度 - 表头高度 / 单独每行高度
      return Math.floor((appContainerHeight - 142) / 37);
    }
  },
  created() {
    this._getList();
  },
  methods: {
    //Todo 表格所需函数 start
    _getList() {
      const obj = {};
      obj.tabId = "0";
      if (arguments.length) {
        if (arguments[0] === "single") {
          for (let key in this.singleDataToEnd) {
            obj[key] = this.singleDataToEnd[key];
          }
          obj.pageNo = this.pageNoCode;
          obj.pageSize = this.getPageSizeCode;
        } else if (arguments[0] === "multi") {
          for (let key in this.multiDataToEnd) {
            obj[key] = this.multiDataToEnd[key];
          }
          obj.pageNo = this.pageNoCode;
          obj.pageSize = this.getPageSizeCode;
        }
      } else {
        obj.pageNo = this.pageNoCode;
        obj.pageSize = this.getPageSizeCode;
      }
      obj.isShowPageLoading = true;
      getList(obj).then(res => {
        this.isShowPagination = res.data.data.recordsTotal > 0;
        this.tableData = res.data.data.rows;
        this.totalNum = res.data.data.recordsTotal;
        this.pageNoCode = res.data.data.pageNo; // 当前页
        this.tableData.forEach((item, index) => {
          item.index = index + 1;
          item.salePrice = "￥" + numberFilter(item.salePrice).newNum;
        });
      });
    },
    selectedItem(data) {
      this.selectData = data;
    },
    handleExport() {},
    handlePrev() {},
    handleNext() {},
    handleSizeChange(val) {
      this.pageNoCode = 1;
      val !== "none" && (this.getPageSizeCode = val);
      if (this.searchBtnStatus === "single") {
        this._getList("single");
      } else {
        this._getList("multi");
      }
    },
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.pageNoCode = val;
      if (this.searchBtnStatus === "single") {
        this._getList("single");
      } else {
        this._getList("multi");
      }
    },
    handleApproval() {},
    //Todo 表格所需函数 end
    //Todo 高级搜索所需函数 start
    searchItem(searchData) {}
    //Todo 高级搜索所需函数 end
  },
  beforeRouteLeave(to, from, next) {
    for (var key in this.$vnode.parent.componentInstance.cache) {
      delete this.$vnode.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  }
};
</script>

<style lang="scss"></style>
